export const INSUFFICIENT_PERMISSION_MESSAGE = 'Insufficient permission for this resource'
